import { getPitchTypeColor } from 'bam-node-baseball-savant/utils/pitch-type-colors'
import { EVPData } from '../../schema/types.ts'

export default function Color(
    // TODO: Can we track down the remaining five outliers?
    type:
        | keyof EVPData
        | 'bb_type'
        | 'bbType'
        | 'pitch_name'
        | 'homeRunTypes'
        | 'pitch_type',
    value: string
) {
    try {
        if (
            (type === 'bb_type' ||
                type === 'bbType' ||
                type === 'battedBallType') &&
            value &&
            value !== 'NULL'
        ) {
            if (
                Number(value) === 4 ||
                value === 'Ground Ball' ||
                value === 'ground_ball'
            ) {
                return '#B71484'
            }
            if (
                Number(value) === 3 ||
                value === 'Line Drive' ||
                value === 'line_drive'
            ) {
                return '#eced4d'
            }
            if (Number(value) === 2 || value === 'Popup' || value === 'popup') {
                return '#DE1E24'
            }
            if (
                Number(value) === 1 ||
                value === 'Fly Ball' ||
                value === 'fly_ball'
            ) {
                return '#505F39'
            }
        }
        if (type === 'pitchResult' && value) {
            if (
                value === 'Ball' ||
                value === 'ball' ||
                value === 'blocked_ball'
            ) {
                return '#1F77B4'
            }
            if (value === 'Called Strike' || value === 'called_strike') {
                return '#FF7F0E'
            }
            if (value === 'Foul' || value.indexOf('foul') > -1) {
                return '#2CA02C'
            }
            if (
                value === 'In play, no out' ||
                value === 'hit_into_play_no_out'
            ) {
                return '#D62728'
            }
            if (value === 'In play, out(s)' || value === 'hit_into_play') {
                return '#9467BD'
            }
            if (
                value === 'In play, run(s)' ||
                value === 'hit_into_play_score'
            ) {
                return '#8C564B'
            }
            if (
                value === 'Swinging Strike' ||
                value === 'swinging_strike' ||
                value === 'swinging_strike_blocked'
            ) {
                return '#E377C2'
            }
            return '#000000'
        }
        if ((type === 'call_name' || type === 'callName') && value) {
            if (value.toLowerCase() === 'ball') {
                return '#1F77B4'
            }
            if (value.toLowerCase() === 'strike') {
                return '#FF7F0E'
            }
            if (
                value.toLowerCase() === 'in play' ||
                value.toLowerCase() === 'in_play'
            ) {
                return '#2CA02C'
            }
            return '#000'
        }
        if (type === 'paResult' && value) {
            try {
                if (value.toLowerCase() === 'single') {
                    return '#FE6100'
                }
                if (value.toLowerCase() === 'double') {
                    return '#785EF0'
                }
                if (value.toLowerCase() === 'triple') {
                    return '#FFB000'
                }
                if (
                    value.toLowerCase() === 'home_run' ||
                    value.toLowerCase() === 'home run'
                ) {
                    return '#DC267F'
                }
                if (value.toLowerCase() === 'walk') {
                    return '#565D97'
                }
                if (value.toLowerCase().indexOf('strikeout') > -1) {
                    return '#791734'
                }
                if (value.toLowerCase().indexOf('sac') > -1) {
                    return '#cc6600'
                }
                if (value.toLowerCase().indexOf('error') > -1) {
                    return '#999900'
                }
                if (value.toLowerCase().indexOf('hit_by_pitch') > -1) {
                    return '#28282b'
                }
                return '#c2c2c2'
            } catch (ex) {
                return '#c2c2c2'
            }
        }
        if (
            (type === 'pitch_name' ||
                type === 'pitchName' ||
                type === 'pitch_type' ||
                type === 'pitchType') &&
            value
        ) {
            return getPitchTypeColor(value, false)
        }
        if (type === 'isInZone') {
            // Would like to change these colors
            return value === 'false'
                ? 'rgb(121, 121, 255)'
                : 'rgb(235, 125, 115)'
        }
    } catch (ex) {
        return '#c2c2c2'
    }
    if (type === 'homeRunTypes' && value) {
        try {
            if (value === 'No Doubter') {
                return '#ff5722'
            }
            if (value === 'Mostly Gone') {
                return '#3a9098'
            }
            return '#9e9e9e'
        } catch (ex) {
            return '#c2c2c2'
        }
    }
}
